import styled from 'styled-components';
import { Popover } from 'antd';

const fillWeekBlue = '#0066b3';

const StyledCopyPreviousPopover = styled(Popover)`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  white-space: nowrap;
  color: ${fillWeekBlue};
  background-color: #fff;
  border: 1px solid ${fillWeekBlue};
  border-radius: 2px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: #e8f2fa;
    border-color: #004f8a;
    color: #004f8a;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

const CopyWeekWarningContent = styled.div`
  max-width: 280px;
`;

const CopyWeekWarningText = styled.p`
  margin: 0;
  color: #343434;
  line-height: 1.4;
`;

const CopyWeekWarningSubtext = styled.p`
  margin: 0.45rem 0 0;
  color: #666;
  font-size: 0.85rem;
  line-height: 1.4;
`;

const CopyWeekWarningActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.85rem;
`;

export {
  StyledCopyPreviousPopover,
  CopyWeekWarningContent,
  CopyWeekWarningText,
  CopyWeekWarningSubtext,
  CopyWeekWarningActions,
};
